if (window.innerWidth > 768) {
  const sr = ScrollReveal({
    origin: 'top',
    distance: '60px',
    duration: 1500,
    delay: 100,
    // reset: true,
  });

  sr.reveal('.care_img', {
    origin: 'left',
    duration: 500,
    reset: true,
    delay: 200,
  });
  sr.reveal('.care_list', {
    origin: 'right',
    duration: 500,
    reset: true,
    delay: 200,
  });
  sr.reveal('.ecotree-wrap', {
    scale: 0.5,
    duration: 500,
    delay: 400,
    reset: true,
  });
  sr.reveal('.testimonial', {
    origin: 'right',
    duration: 600,
    delay: 800,
    distance: '160px',
  });
}
